export default __webpack_public_path__ + "static/media/evasiveaction.82990572.png";